var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "share-session",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9871",
    "data-name": "Path 9871",
    d: "M11,35a11.014,11.014,0,1,1,9.832-6.078A11.013,11.013,0,0,1,11,35Zm0-20a9,9,0,1,0,8.046,13.022,8.959,8.959,0,0,0,0-8.04A8.952,8.952,0,0,0,11,15Z",
    fill: "#00838d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9872",
    "data-name": "Path 9872",
    d: "M11,26a4.006,4.006,0,1,1,2.354-.769A4.017,4.017,0,0,1,11,26Zm0-6a2,2,0,0,0-2,2,1.958,1.958,0,0,0,.814,1.608,2.034,2.034,0,0,0,2.362.006A1.96,1.96,0,0,0,13,22,2,2,0,0,0,11,20Z",
    fill: "#00838d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9873",
    "data-name": "Path 9873",
    d: "M15,30H7a1,1,0,0,1-1-1V28a4.959,4.959,0,0,1,2.789-4.477,1,1,0,0,1,1.034.091,2.041,2.041,0,0,0,2.354,0,1,1,0,0,1,1.03-.094,5.1,5.1,0,0,1,1.317.93A5.021,5.021,0,0,1,16,28v1A1,1,0,0,1,15,30ZM8,28h6a3.018,3.018,0,0,0-.882-2.128,3.126,3.126,0,0,0-.346-.288,4.065,4.065,0,0,1-3.544,0A2.969,2.969,0,0,0,8,28Zm29-6A11,11,0,1,1,48,11,10.941,10.941,0,0,1,37,22ZM37,2a9.01,9.01,0,0,0-9,9,8.8,8.8,0,0,0,.951,4.017A9,9,0,1,0,37,2Z",
    fill: "#00838d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9874",
    "data-name": "Path 9874",
    d: "M37,13a4.006,4.006,0,1,1,2.354-.769A4.017,4.017,0,0,1,37,13Zm0-6a2,2,0,0,0-2,2,1.958,1.958,0,0,0,.814,1.608,2.034,2.034,0,0,0,2.362.006A1.96,1.96,0,0,0,39,9,2,2,0,0,0,37,7Z",
    fill: "#00838d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9875",
    "data-name": "Path 9875",
    d: "M41,17H33a1,1,0,0,1-1-1V15a4.959,4.959,0,0,1,2.789-4.477,1,1,0,0,1,1.034.091,2.041,2.041,0,0,0,2.354,0,1,1,0,0,1,1.03-.094,5.1,5.1,0,0,1,1.317.93A5.021,5.021,0,0,1,42,15v1A1,1,0,0,1,41,17Zm-7-2h6a3.018,3.018,0,0,0-.882-2.128,3.126,3.126,0,0,0-.346-.288,4.065,4.065,0,0,1-3.544,0A2.969,2.969,0,0,0,34,15Zm3,33A11,11,0,1,1,48,37,11.013,11.013,0,0,1,37,48Zm0-20a8.949,8.949,0,0,0-8.046,4.977A8.8,8.8,0,0,0,28,37a9,9,0,1,0,9-9Z",
    fill: "#00838d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9876",
    "data-name": "Path 9876",
    d: "M37,39a4.006,4.006,0,1,1,2.354-.769A4.017,4.017,0,0,1,37,39Zm0-6a2,2,0,0,0-2,2,1.958,1.958,0,0,0,.814,1.608,2.034,2.034,0,0,0,2.362.006A1.96,1.96,0,0,0,39,35,2,2,0,0,0,37,33Z",
    fill: "#00838d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9877",
    "data-name": "Path 9877",
    d: "M41,43H33a1,1,0,0,1-1-1V41a4.959,4.959,0,0,1,2.789-4.477,1,1,0,0,1,1.034.091,2.041,2.041,0,0,0,2.354,0,1,1,0,0,1,1.03-.094,5.1,5.1,0,0,1,1.317.93A5.021,5.021,0,0,1,42,41v1A1,1,0,0,1,41,43Zm-7-2h6a3.018,3.018,0,0,0-.882-2.128,3.126,3.126,0,0,0-.346-.288,4.065,4.065,0,0,1-3.544,0A2.969,2.969,0,0,0,34,41ZM19.941,20.53a1,1,0,0,1-.449-1.895l8.119-4.06a1,1,0,1,1,.895,1.789l-8.119,4.06A.988.988,0,0,1,19.941,20.53Zm8.118,13a1,1,0,0,1-.446-.1l-8.119-4.06a1,1,0,1,1,.9-1.789l8.119,4.06a1,1,0,0,1-.449,1.894Z",
    fill: "#00838d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareSession);
export default __webpack_public_path__ + "static/media/share-session.7fffc04bc5dc38cb808a90ae79503af6.svg";
export { ForwardRef as ReactComponent };